import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { ContactEngagement } from '@interfaces';
import { AppService } from '../../../../../services';
import { AccApplicationDialogDataService } from '../../acc-application-dialog-data.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(pageService: AccApplicationDialogDataService, util: UtilityService, dialog: DialogService, app: AppService): GridSetup<ContactEngagement> {

	return {
		rowName: { singular: 'Engagement', plural: 'Engagements' },
		getRowKey: row => '' + row.id,
		stateKey: 'acc-application-dialog-engagements-grid',
		actions: getActions(pageService, dialog),
		buttons: getButtons(pageService, dialog),
		columns: getColumns(util, app),
	}
}
